/**
 * Route for `fully-customizable-dashboard-widgets`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FullyCustomizableDashboardWidgetsPage } from "../features/fully-customizable-dashboard-widgets/FullyCustomizableDashboardWidgetsPage";

export const fullyCustomizableDashboardWidgetsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fully-customizable-dashboard-widgets",
	component: FullyCustomizableDashboardWidgetsPage,
});

export default fullyCustomizableDashboardWidgetsRoute;
